// extracted by mini-css-extract-plugin
module.exports = {"main":"suspended_main__q8KSm"};